import { APIFailureWrapper, mockFlag } from '@/utils/mock'
import { diseases } from '@/modules/execution/mock/diseasesSeeds'
import { cropsByName } from '@/services/__mocks__/cropsSeeds'
import { defensives } from '@/modules/execution/mock/executionsSeeds'

const executionRoutes = [
  // defensives
  mockFlag(
    {
      method: 'get',
      url: '/defensives',
      result: () => {
        const response = defensives.map((defensive) => {
          return {
            id: defensive.id,
            nome: defensive.nome,
            unidade: defensive.unidade,
            tipo: defensive.tipo,
            pais_id: defensive.pais_id,
            is_white_mold: defensive.is_white_mold,
            doses: defensive.doses,
          }
        })

        return APIFailureWrapper({
          content: response,
          errorMessage: 'Erro na listagem de defensivos',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'get',
      url: '/defensives/last-values',
      result: () => {
        const response = defensives.reduce((acc, defensive, index) => {
          acc[index] = {
            defensivo_id: defensive.id,
            dose: String(Math.floor(Math.random() * 10) + 1),
            preco: String(Math.floor(Math.random() * 10) + 1),
            ranking: 1,
          }
          return acc
        }, {})

        return APIFailureWrapper({
          content: response,
          errorMessage: 'Erro na listagem de últimos defensivos',
        })
      },
    },
    'on'
  ),
  // diseases
  mockFlag(
    {
      method: 'post',
      url: '/defensives/suggest',
      result: () => {
        // Hardcoded no momento pq não é o foco
        const response = [
          {
            position: 5,
            defensives: [
              {
                dose: null,
                price: null,
                unit: null,
                defensive: {
                  id: 729,
                  name: 'Across',
                  type: null,
                  active_ingredients: [
                    {
                      id: 36,
                      name: 'Difenoconazole',
                    },
                    {
                      id: 7,
                      name: 'Chlorothalonil',
                    },
                    {
                      id: 18,
                      name: 'Azoxystrobin',
                    },
                  ],
                },
              },
            ],
            ideal_date: null,
            applied_at: null,
            efficacies: [
              {
                disease_id: 1,
                efficacy: {
                  potencial: 0.6697500000000007,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
              {
                disease_id: 2,
                efficacy: {
                  potencial: 0.7510600000000008,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
              {
                disease_id: 3,
                efficacy: {
                  potencial: 0.7144000000000007,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
              {
                disease_id: 4,
                efficacy: {
                  potencial: 0.6470960000000007,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
              {
                disease_id: 5,
                efficacy: {
                  potencial: 0.7590500000000009,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
              {
                disease_id: 11,
                efficacy: {
                  potencial: 0.866304000000001,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
            ],
            prioritary_disease: null,
            secondary_disease: null,
          },
          {
            position: 5,
            defensives: [
              {
                dose: null,
                price: null,
                unit: null,
                defensive: {
                  id: 809,
                  name: 'Armero',
                  type: null,
                  active_ingredients: [
                    {
                      id: 10,
                      name: 'Prothioconazole',
                    },
                    {
                      id: 6,
                      name: 'Mancozeb',
                    },
                  ],
                },
              },
            ],
            ideal_date: null,
            applied_at: null,
            efficacies: [
              {
                disease_id: 1,
                efficacy: {
                  potencial: 0.7858400000000008,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
              {
                disease_id: 2,
                efficacy: {
                  potencial: 0.7068800000000007,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
              {
                disease_id: 3,
                efficacy: {
                  potencial: 0.7233300000000007,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
              {
                disease_id: 4,
                efficacy: {
                  potencial: 0.6559320000000007,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
              {
                disease_id: 5,
                efficacy: {
                  potencial: 0.7590500000000009,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
              {
                disease_id: 11,
                efficacy: {
                  potencial: 0.866304000000001,
                  current: 0,
                },
                severity_id: 1,
                no_register_for_disease: false,
              },
            ],
            prioritary_disease: null,
            secondary_disease: null,
          },
        ]

        return APIFailureWrapper({
          content: response,
          errorMessage: 'Erro na listagem de últimos defensivos',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'get',
      url: '/diseases',
      result: ({ queryParams }) => {
        let cropName = 'soybean'
        const soybeanSeasonCrops = ['5', '16']
        if (!soybeanSeasonCrops.includes(queryParams.seasonCrop)) {
          cropName = 'wheat'
        }

        const filteredDiseases = diseases.filter(
          (disease) => disease.crop_id == cropsByName[cropName].id
        )

        const response = filteredDiseases.map((disease) => {
          return {
            id: disease.id,
            name: disease.name,
            crop_id: disease.crop_id,
            code: disease.code,
          }
        })

        return APIFailureWrapper({
          content: response,
          errorMessage: 'Erro na listagem de doenças',
        })
      },
    },
    'on'
  ),
  // irrigations
  mockFlag(
    {
      method: 'get',
      url: '/irrigacoes',
      result: () => {
        const response = []

        return APIFailureWrapper({
          content: response,
          errorMessage: 'Erro na listagem de irrigacoes',
        })
      },
    },
    'on'
  ),
  mockFlag(
    {
      method: 'get',
      url: '/programas/:id/planejamentos/sugerir',
      result: () => {
        // Hardcoded no momento pq não é o foco
        const response = {
          doencas: {
            prioritaria_id: 1,
            secundaria_1_id: 5,
            secundaria_2_id: null,
          },
        }

        return APIFailureWrapper({
          content: response,
          errorMessage: 'Erro na sugestão de doenças',
        })
      },
    },
    'on'
  ),
]

export { executionRoutes }
